import { render, staticRenderFns } from "./PayPalForm.vue?vue&type=template&id=289b65c2"
import script from "./PayPalForm.vue?vue&type=script&lang=js"
export * from "./PayPalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports